// removed by extract-text-webpack-plugin
module.exports = {"box":"_4n5dp5a9wa6nu34gw2s5rafu5r5ypb32buvxdz31wycb2vtcyuqv7dgf97j6nwgyqeefk7n63nvu56frnwfxvczq3zk9ajf635m4dmq-styles-module-box","textBox":"_2et19n13htd73u5t5mzst5suj6f8amha2pexbnv5wst3cyjd2p1qqahk2qyav755g1chsa89cutdade91fntpxt2xm6r8epc1jkachm-styles-module-textBox","textField":"_4xkn4a3wa4kmab6j42dgvnf14dek5m4usccdpezqp3shdprp82bx32mzzzcb3pvn61qchnne7r6mgvpmuz64d9rg954y225gdu5j3j1-styles-module-textField","sendButtonBox":"_4w1ry5rc39v72u65prjnyma63xbjcmvw74ykmwj3xpfyn1k6a1gq2uysmwbkfkhunmy32ujngjxpgb2daq3wrjn5e3tg5shyzyt5n9x-styles-module-sendButtonBox"};


//////////////////
// WEBPACK FOOTER
// ./src/components/common/CommentSend/styles.module.sass
// module id = 442
// module chunks = 0